import React, { useEffect, useState } from "react";
import { FaCircleExclamation } from "react-icons/fa6";
import { useSelector } from "react-redux";

const DataSyncFailed = () => {
  const [isChanged, setIsChanged] = useState(false);
  const { dataSyncTime } = useSelector((state) => state.user);

  useEffect(() => {
    if (!dataSyncTime?.value) {
      setIsChanged(false);
      return;
    }
    const lastSync = new Date(dataSyncTime.value);
    const now = new Date();
    const diffInHours = (now - lastSync) / (1000 * 60 * 60);
    if (diffInHours >= 24) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  }, [dataSyncTime]);

  if (!isChanged) {
    return null;
  }

  return (
    <div className="bg-[#FFECEB] text-[#990800] border border-[#FFBBB8] justify-center flex items-center gap-2 text-sm font-medium shadow-sm px-4 py-2 rounded">
      <FaCircleExclamation className="w-5 h-5 text-[#D10B00]" />
      <div className="text-[16px]">
        <span className="font-medium">
          Sync for today failed. Reach out to the administrator at{" "}
          <a
            href="mailto:an.smith@cell.com"
            className="text-[#1C40CA] underline"
          >
            an.smith@cell.com
          </a>{" "}
          for support.
        </span>
      </div>
    </div>
  );
};

export default DataSyncFailed;
